import React from 'react'

export default function right(color, size) {
    return (<svg height={size} id="Layer_1" version="1.1" viewBox="0 0 512 512" width={size} xmlns="http://www.w3.org/2000/svg" data-name="forward" >
        <polygon points="160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 " stroke={color} />
    </svg>)
}